var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useForm } from "react-hook-form";
import { useEffect, useId } from "react";
import Button from "../../Button";
import Form from "../../Form";
import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { InputField } from "../../Input";
import { isEmpty } from "../../Util/TextUtils";
var SearchControl = function (_a) {
    var pageRequest = _a.pageRequest, setPageRequest = _a.setPageRequest;
    var _b = useForm(), register = _b.register, getValues = _b.getValues, setValue = _b.setValue, handleSubmit = _b.handleSubmit, reset = _b.reset;
    var id = useId();
    useEffect(function () {
        var _a;
        if ((_a = pageRequest.search) === null || _a === void 0 ? void 0 : _a.query) {
            setValue("searchQuery", pageRequest.search.query);
        }
    }, []);
    if (pageRequest.search === undefined) {
        return _jsx(_Fragment, {});
    }
    var setSearchQuery = function (searchQuery) {
        var newRequest = __assign({}, pageRequest);
        if (newRequest.search) {
            newRequest.search.query = searchQuery;
            setPageRequest(newRequest);
        }
    };
    return (_jsxs("div", __assign({ className: "flex gap-2 items-end" }, { children: [!isEmpty(pageRequest.search.query)
                ? _jsx(Button, { type: "danger", text: pageRequest.search.messages.clear, onClick: function () {
                        reset();
                        setSearchQuery(undefined);
                    } })
                : _jsx(_Fragment, {}), _jsx(Form, __assign({ onSubmit: handleSubmit(function () { return setSearchQuery(getValues("searchQuery")); }), error: null }, { children: _jsx(InputField, { type: "text", id: id, displayName: pageRequest.search.messages.search, placeholder: pageRequest.search.messages.placeholder, trailingButton: {
                        type: "gray",
                        iconOnly: true,
                        text: pageRequest.search.messages.search,
                        icon: MagnifyingGlassIcon
                    }, hideLabel: true, reactHookForm: __assign({}, register("searchQuery", {
                        maxLength: 512
                    })) }) }))] })));
};
export default SearchControl;
